import { useMemo } from 'react';
import { FormattedFields } from './useFormFieldsSharedLogic';

const useFieldValues = (fields: FormattedFields) => {
  const label = useMemo(() => fields.label?.value, [fields.label]);
  const tooltip = useMemo(() => fields.tooltip?.value, [fields.tooltip]);
  // const errorMessage = useMemo(() => fields.errorMessages.value, [fields.errorMessages]);
  // const validationPatterns = useMemo(() => fields.validations?.value ?? [], [fields.validations]);
  const hintMessage = useMemo(() => fields.hint?.value, [fields.hint]);
  const minLength = fields.min?.value;
  const maxLength = fields.max?.value;
  const minNumber = fields.minNumberValue;
  const maxNumber = fields.maxNumberValue;

  return {
    label,
    tooltip,
    // errorMessage,
    // validationPatterns,
    hintMessage,
    minLength,
    maxLength,
    minNumber,
    maxNumber,
  };
};

export default useFieldValues;
